export default __webpack_public_path__ + "static/real-world-back-6469afef92d84ea3c6ae352f785ea6d7.webp";